import useGlobalFlag from 'hooks/useGlobalFlag'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import { usePermission } from 'enrollment-platform/rbac/usePermission'

import {
  US_RESTRICTED_CARRIER_NAME_PATTERN,
  US_RESTRICTED_DATA_ENFORCEMENT_FLAG,
} from '../../../shared/constants'

/**
 * Whether the carrier page may show per-member failure rows (Recent failed
 * attempts table, Download Excel). While the EPS global enforcement flag is
 * on, US-restricted carriers need UsRestrictedData:Manage; hidden while the
 * flag or permission is still loading so the rows never flash. EPS filters
 * the same rows server-side on the same flag.
 */
export function useCanViewMemberFailures(carrierName: string | null): boolean {
  const { isEnabled: isEnforced, isLoading: isFlagLoading } = useGlobalFlag(
    US_RESTRICTED_DATA_ENFORCEMENT_FLAG
  )
  const { allowed, isLoading } = usePermission(
    RbacActions.Manage,
    RbacSubjects.UsRestrictedData
  )
  if (!carrierName || !US_RESTRICTED_CARRIER_NAME_PATTERN.test(carrierName)) {
    return true
  }
  if (isFlagLoading) return false
  if (!isEnforced) return true
  return allowed && !isLoading
}
